module.exports = __webpack_public_path__ + "static/media/undraw_welcome_3gvl.2409ca6b.svg";